module.exports = __webpack_public_path__ + "media/img/vca/bg-cat-e2b23e174b5c9389b53e33ed426b8891.png";